import Grid from '@material-ui/core/Grid';

import Step from './Step';
import Step2 from 'images/createAccount/okta_verify_step2.png';
import Step3 from 'images/createAccount/okta_verify_step3.png';
import Step3Mobile from 'images/createAccount/okta_verify_step3_mobile.png';
import Stores from './Stores';

const Instructions = props => {
  const { isMobile } = props;
  return (
    <>
      <Grid item xs={12}>
        <Step number={1} isMobile={isMobile}>
          Download the Okta Verify application from the Apple App Store, Google
          Play or Windows App Store
        </Step>
        <Stores isMobile={isMobile} />
      </Grid>
      <Grid item xs={12}>
        <Step number={2} isMobile={isMobile}>
          Launch application and Select “Add Account”
        </Step>
        <img src={Step2} alt="Okta Verify Step 2" />
      </Grid>
      <Grid item xs={12}>
        <Step number={3} isMobile={isMobile}>
          {isMobile
            ? `Tap "No Barcode" and you'll be redirected to a screen to type in a secret key`
            : `Hold the device up to you computer monitor and Scan the QR code`}
        </Step>
        <img src={isMobile ? Step3Mobile : Step3} alt="Okta Verify Step 3" />
      </Grid>
      <Grid item xs={12}>
        <Step number={4} isMobile={isMobile}>
          {isMobile
            ? `Tap “Get secret key”, and copy code from screen. Go back to the Okta Verify app and paste the code in the secret key area.`
            : `A six digit code will display in your Okta Verify application after
          scanning the QR code. Then enter that six digit code on your computer and verify.`}
        </Step>
      </Grid>
      {isMobile && (
        <Grid item xs={12}>
          <Step number={5} isMobile={isMobile}>
            Okta Verify will generate a six digit code. Go back to the create
            account screen and type in the six digit code and verify.
          </Step>
        </Grid>
      )}
    </>
  );
};

export default Instructions;
